import React from 'react';

import AssignmentIcon from '@material-ui/icons/Assignment';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ListAltIcon from '@material-ui/icons/ListAlt';

import { PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR } from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';
import StyledMenuItemLink from './StyledMenuItemLink';

const SubMenuGlobal = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Global"
    icon={<AssignmentIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_mensal_vendas"
        to="/relatorio_mensal_vendas"
        primaryText="Relatório Mensal"
        leftIcon={<AttachMoneyIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_anual_vendas"
        to="/relatorio_anual_vendas"
        primaryText="Relatório Anual"
        leftIcon={<AttachMoneyIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_produtos"
        to="/relatorio_produtos"
        primaryText="Relatório Produtos"
        leftIcon={<AttachMoneyIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_clientes"
        to="/relatorio_clientes"
        primaryText="Relatório Clientes"
        leftIcon={<AttachMoneyIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] && (
      <StyledMenuItemLink
        key="indicadores_kpi"
        to="/indicadores_kpi"
        primaryText="Indicadores kpi"
        leftIcon={<AttachMoneyIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] && (
      <StyledMenuItemLink
        key="inventario"
        to="/inventario"
        primaryText="Inventário"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_cadastro_clientes"
        to="/relatorio_cadastro_clientes"
        primaryText="Cadastro Clientes"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_produtos_setores_inventario"
        to="/relatorio_produtos_setores_inventario"
        primaryText="Produtos de um local"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_produtos_colaborador_inventario"
        to="/relatorio_produtos_colaborador_inventario"
        primaryText="Produtos colaborador"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_produtos_colaborador_fardamento"
        to="/relatorio_produtos_colaborador_fardamento"
        primaryText="Fardamentos Colaborador"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
  </SubMenu>
);

export default SubMenuGlobal;
